// config
import * as http from 'utils/http';
import config from 'config';

export const getTicketAgencies = async (ticketId) => {
  return await http.get(
    `${config.API_URL}price-negotiation/tickets/${ticketId}/available-agencies/`
  );
};
